import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertCircle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, className }) => {
  if (!IconComponent) return <FiAlertCircle className={className} />;
  return <IconComponent className={className} />;
};

export default SafeIcon;